export type TimerSettings = { exercise: number; rest: number; rounds: number };
export function getTimerState(elapsed: number, settings: TimerSettings) {
  const { exercise, rest, rounds } = settings;
  const total = exercise * rounds + rest * (rounds - 1);
  if (elapsed >= total)
    return {
      phase: "complete" as const,
      round: rounds,
      remaining: 0,
      duration: exercise,
      total,
    };
  const round = Math.floor(elapsed / (exercise + rest)) + 1;
  const offset = elapsed % (exercise + rest);
  const phase = offset < exercise ? ("exercise" as const) : ("rest" as const);
  const duration = phase === "exercise" ? exercise : rest;
  return {
    phase,
    round,
    remaining: Math.ceil(
      phase === "exercise" ? exercise - offset : exercise + rest - offset,
    ),
    duration,
    total,
  };
}
